import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export function BigWord({ word, align = "left" }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["5%", "-6%"]);

  return (
    <div ref={ref} className="overflow-hidden py-6 md:py-10 select-none" aria-hidden="true" data-testid={`bigword-${word.toLowerCase()}`}>
      <motion.p
        style={reduced ? { WebkitTextStroke: "1px rgba(15,15,15,0.14)" } : { x, WebkitTextStroke: "1px rgba(15,15,15,0.14)" }}
        className={`font-serif font-medium leading-[0.85] text-[22vw] md:text-[16vw] whitespace-nowrap text-transparent ${
          align === "right" ? "text-right" : ""
        }`}
      >
        {word}
      </motion.p>
    </div>
  );
}
